import { Grid } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import useDashboardStyles from "../../index.styles";
import useStyles from "./Skeleton.styles";

export default function DashboardSkeleton() {
	const classes = useStyles();
	const dashboardClasses = useDashboardStyles();

	return (
		<div className={dashboardClasses.root}>
			{/* Esqueleto do Cabeçalho */}
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					marginBottom: "24px",
				}}
			>
				<Skeleton
					variant="rect"
					animation="wave"
					width={365}
					height={69}
					className={classes.skeleton}
				/>
				<Skeleton
					variant="rect"
					animation="wave"
					width={380}
					height={56}
					className={classes.skeleton}
				/>
			</div>

			<div className={dashboardClasses.rows}>
				{/* Esqueleto dos 3 Cards de Resumo */}
				<Grid container spacing={2}>
					{[1, 2, 3].map((key) => (
						<Grid item xs={4} key={key}>
							<Skeleton
								variant="rect"
								animation="wave"
								height={168}
								style={{ borderRadius: 4 }}
								className={classes.skeleton}
							/>
						</Grid>
					))}
				</Grid>

				{/* Esqueleto do Resumo de Progresso e Cards de Status */}
				<Grid container spacing={2}>
					<Grid item xs={12} lg={8}>
						<Skeleton
							variant="rect"
							animation="wave"
							height={300}
							style={{ borderRadius: 4 }}
							className={classes.skeleton}
						/>
					</Grid>
					<Grid item xs={12} lg={4}>
						<div className={dashboardClasses.statusCardsWrapper}>
							{[1, 2].map((key) => (
								<div className={dashboardClasses.statusCardsItem} key={key}>
									<Skeleton
										variant="rect"
										animation="wave"
										height={142}
										style={{ borderRadius: 4 }}
										className={classes.skeleton}
									/>
								</div>
							))}
						</div>
					</Grid>
				</Grid>

				{/* Esqueleto das 2 Tabelas inferiores */}
				<Grid container spacing={2}>
					{[1, 2].map((key) => (
						<Grid item xs={12} lg={6} key={key}>
							<Skeleton
								variant="rect"
								animation="wave"
								height={502}
								style={{ borderRadius: 4 }}
								className={classes.skeleton}
							/>
						</Grid>
					))}
				</Grid>

				{/* Esqueleto do Alerta de Retirada (WithdrawalAlert) */}
				<Skeleton
					variant="rect"
					animation="wave"
					height={64}
					style={{ borderRadius: 4 }}
					className={classes.skeleton}
				/>
			</div>
		</div>
	);
}
